import { WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const warrantyLogWaUsersQueryKey = 'warrantyLogWaUsersQueryKey';

export const useWarrantyWaUsers = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWaUsers>>,
      QueryError,
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWaUsers>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [warrantyLogWaUsersQueryKey, ...(queryKey ?? [])],
    () => WarrantyLogService.getWarrantyLogWaUsers(),
    options
  );
